// extracted by mini-css-extract-plugin
export default {"eventTicketsHeader":"eventTicketsHeader_eventTicketsHeader__i-t4S","eventTicketsHeaderDetails":"eventTicketsHeader_eventTicketsHeaderDetails__CBzL8"};